import type { AdminCrewReportRepatriationTableRowProps } from "../../models/admin-crew-report.models";
import { ADMIN_CREW_REPORT_REPATRIATION_COLUMNS } from "../../utils/admin-crew-report.constants";

const AdminCrewReportRepatriationTableRow = ({ category }: AdminCrewReportRepatriationTableRowProps) => {
  return (
    <tr className="grid grid-cols-[18%_repeat(5,minmax(0,1fr))] border-b border-[#D8E6E3] last:border-b-0 dark:border-gray-700">
      <th scope="row" className="break-words px-1 py-2 text-left font-medium leading-3">
        {category.name}
      </th>
      {ADMIN_CREW_REPORT_REPATRIATION_COLUMNS.map((column) => (
        <td
          key={column.key}
          className={`flex items-center justify-center px-1 py-2 text-center leading-3 ${
            column.key === "totalVesselCount" ? "font-semibold" : ""
          }`}
        >
          {category[column.key]}
        </td>
      ))}
    </tr>
  );
};

export default AdminCrewReportRepatriationTableRow;
